module.exports = __webpack_public_path__ + "img/2-3.46a56f50.png";